import React, { Component } from "react";
import { connect } from "react-redux";
// import xlsx from "xlsx";
import LocateSitesMap from "./localSitesMap";
import {
	getSitesLatLong,
	generateLocateSiteExcel
} from "../../actions/locateSitesActions";
import DownloadLocateSitePPT from "./downloadLocateSItesPPT";

class LocateSites extends Component {
	state = {
		file_msg: "Upload Excel File",
		value: "",
		textAreaValue: ""
	};

	// handleFileChange = e => {
	// 	this.setState({ value: e.target.value });

	// 	if (e.target.files.length > 0) {
	// 		const file = e.target.files[0];

	// 		if (file.type === "application/vnd.ms-excel") {
	// 			this.setState({
	// 				file_msg: "File Choosen " + file.name
	// 			});

	// 			const reader = new FileReader();

	// 			reader.onerror = e => {
	// 				console.log("Error Reading File", e);
	// 			};

	// 			reader.onload = e => {
	// 				let bstr = e.target.result;
	// 				const wb = xlsx.read(bstr, { type: "binary" });
	// 				const wsname = wb.SheetNames[0];
	// 				const ws = wb.Sheets[wsname];
	// 				const data = xlsx.utils.sheet_to_json(ws);
	// 				let site_code_array = data.map(item => {
	// 					return item["Site Code"];
	// 				});

	// 				this.props.getSitesLatLong(site_code_array);

	// 				this.setState({ value: "", file_msg: "Upload New Excel" });
	// 			};

	// 			reader.readAsBinaryString(file);
	// 		} else {
	// 			this.setState({ file_msg: "Please choose excel file" });
	// 		}
	// 	}
	// };

	handleTextAreaChange = e => {
    let textAreaValue = e.target.value;

    if(textAreaValue.includes(",")){
      textAreaValue = textAreaValue.trim("\n").split(",");
    } else {
      textAreaValue = textAreaValue.trim("\n").split("\n");
    }

		this.setState({ textAreaValue });
  };
  
  hanldeSubmitButton = () => {
    const { textAreaValue } = this.state;
    this.props.getSitesLatLong(textAreaValue);
  }

	handleExportExcelButton = () => {
		const { generateLocateSiteExcel, locate_site_site_array } = this.props;
		generateLocateSiteExcel(locate_site_site_array);
	};

	render() {
		// const { file_msg, value, textAreaValue } = this.state;
    const { textAreaValue } = this.state;
    const { locate_site_site_array } = this.props;

		return (
			<div className="row">
				<div className="col-md-12 m-3">
					<div className="row">
						<div className="col-md-1">
							{/* <h6>{file_msg}</h6>
							<input
								type="file"
								onChange={this.handleFileChange.bind(this)}
								value={value}
							/> */}
						</div>
						<div className="col-md-6">
							<textarea
								placeholder="Paste Site Codes ( Comma seperated )"
								onChange={this.handleTextAreaChange.bind(this)}
								value={textAreaValue}
								className="col"
							/>
						</div>
            {textAreaValue !=="" && (
              <div className="col-md-1 m-1">
                <button
                  className="btn btn-primary"
                  onClick={this.hanldeSubmitButton.bind(this)}
                >
                  Submit
								</button>
              </div>
            )}
            {locate_site_site_array.length>0 && (
							<div className="col-md-1 m-1">
								<button
									className="btn btn-success"
									onClick={this.handleExportExcelButton.bind(this)}
								>
									Export to Excel
								</button>
							</div>
						)}
            {locate_site_site_array.length > 0 && (
							<DownloadLocateSitePPT site_code_array={textAreaValue} />
						)}
					</div>
				</div>
				<div className="col-md-12">
					<LocateSitesMap
						loadingElement={<div style={{ height: `100%` }} />}
						containerElement={
							<div style={{ height: "90vh", width: "100vw" }} />
						}
						mapElement={<div style={{ height: `100%` }} />}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		locate_site_site_array: state.locateSitesReducer.locate_site_site_array
	};
};

export default connect(
	mapStateToProps,
	{ getSitesLatLong, generateLocateSiteExcel }
)(LocateSites);



// WEBPACK FOOTER //
// ./src/v3/components/locateSites/locateSites.js